import { getStore } from "app/store/store"
import { IOperator } from "operator/model"
import { operatorRPO } from "operator/repository"

export const searchOperatorsByName = async (filter: string, sspIds?: number[]): Promise<IOperator[]> =>
  operatorRPO.getAllOperators(
    sspIds && sspIds.length > 0 ? sspIds : getStore().getState().ssp.ssps.map(ssp => ssp.id),
    filter
  )
